import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCircleInTransit = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => {
    return (
        <div className="icon-block">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 20 20"
                >
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M3.167 13.537h2.878v.804H3.167v-.804zm5.805 0h4.122v.804H8.972v-.804zM2.338 6.073h6.194v.804H2.338v-.804zM1.094 8.147h6.61v.804h-6.61v-.804zm1.244 2.073h4.121v.804H2.338v-.804z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M14.765 12.683a1.257 1.257 0 100 2.513 1.257 1.257 0 000-2.513zm-2.06 1.256a2.06 2.06 0 114.12 0 2.06 2.06 0 01-4.12 0zM7.716 12.683a1.257 1.257 0 100 2.513 1.257 1.257 0 000-2.513zm-2.061 1.256a2.06 2.06 0 114.122 0 2.06 2.06 0 01-4.122 0z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M12.29 4.804H3.568V4h9.524v4.561h3.911l1.895 1.894v3.886h-2.476v-.804h1.671V10.79l-1.423-1.424H12.29v-4.56z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M14.93 6.048h-2.653v-.804h3.15l1.77 3.54-.719.36-1.547-3.096z"
                    clipRule="evenodd"
                ></path>
            </svg>
        </div>
    );
};

export default IconCircleInTransit;
